import { randomUUID } from 'uncrypto';

/**

 *
 * @returns {Object} Object containing the readonly session ID ref
 * @returns {Readonly<Ref<string>>} sessionId - A readonly ref containing the UUID string
 *

 */
export function useSession() {
  let sessionId = {};
  if (import.meta.client) {
    sessionId = useState('session_id', () => randomUUID());
  }

  return { sessionId: readonly(sessionId) };
}
